/** Short ISO-3166-1 alpha-2 list for the org form (extend as customers appear). */
export const COUNTRIES: { code: string; name: string }[] = [
  { code: "AE", name: "United Arab Emirates" },
  { code: "IQ", name: "Iraq" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "IN", name: "India" },
  { code: "GB", name: "United Kingdom" },
  { code: "KW", name: "Kuwait" },
  { code: "QA", name: "Qatar" },
  { code: "BH", name: "Bahrain" },
  { code: "OM", name: "Oman" },
  { code: "TR", name: "Türkiye" },
  { code: "EG", name: "Egypt" },
  { code: "JO", name: "Jordan" },
  { code: "PK", name: "Pakistan" },
  { code: "US", name: "United States" },
];

export function countryName(code: string | null | undefined): string {
  if (!code) return "—";
  return COUNTRIES.find((c) => c.code === code)?.name ?? code;
}
